<template>
  <div id="app">
    <!-- 背景光晕装饰 -->
    <div class="bg-layer" aria-hidden="true">
      <span class="blob blob-1"></span>
      <span class="blob blob-2"></span>
      <span class="blob blob-3"></span>
    </div>

    <router-view class="box" />
    <Updata />
  </div>
</template>

<script>
import Updata from './components/Updata.vue'

export default {
  name: 'App',
  components: {
    Updata
  },
  created() {
    this.$store.state.animationClass = true
  }
}
</script>
